// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {Radio} from '../../lib/radio';
import {Textarea} from '../../lib/textarea';
import {Checkbox} from '../../lib/checkbox';
import Icon_v2 from '../../img/svg/icon/ic-v2.svg';
import styles from './survey.module.less';

interface i_survey_choicegroup_props extends i_survey_choicegroup {
    save: t_survey_save;
}
export const Survey_choicegroup = (props: i_survey_choicegroup_props)=>{
    const {theme} = useContext(Settings_context);
    const cls = cn(styles.survey_choicegroup);
    const {id, text, label, choices, other, save, multiple} = props;
    const [checked, set_checked] = useState<Set<number|string>>(new Set());
    const [options_checked, set_options_checked] = useState(new Set());
    const [msg, set_msg] = useState('');
    const on_answer = (ind: number|string)=>{
        if (!checked.has(ind))
            set_options_checked(new Set());
        if (multiple)
        {
            set_checked(()=>{
                const val = new Set(checked);
                val.has(ind) ? val.delete(ind) : val.add(ind);
                save(id, [...val], val.has('other') ? msg : '');
                return val;
            });
        }
        else
        {
            set_checked(()=>{
                const val = new Set([ind]);
                save(id, [ind], val.has('other') ? msg : '');
                return val;
            });
        }
    };
    const on_choose_option = (ind, opt_ind)=>{
        if (!checked.has(ind))
            set_checked(new Set([ind]));
        options_checked.has(opt_ind) ? options_checked.delete(opt_ind) :
            options_checked.add(opt_ind);
        set_options_checked(new Set(options_checked));
        save(id, ind, options_checked.size > 0 ?
            `Options chosen: ${[...options_checked]}` : '');
    };
    const on_edit = value=>{
        set_msg(value);
        on_answer('other');
    };
    const icon = <Icon_v2 width={10} height={8}/>;
    return <div className={cls}>
      {(text || label) && <div className={styles.text}>
        {text && <p className={theme.bold}>{text}</p>}
        {label && <p className={theme.p2}>{label}</p>}
      </div>}
      <div className={styles.buttons}>
        {choices.map((choice, index)=>{
            const txt = typeof choice=='string' ? choice : choice.value;
            const options = typeof choice=='string' ? null : choice.options;
            return <div key={index} className={cn(styles.survey_choice,
              theme.P, theme.p2, checked.has(index) && styles.chosen)}>
              {multiple ? <Checkbox checked={checked.has(index)} light
                icon={icon} on_change={()=>on_answer(index)} size="sm"
                caption={txt} color="primary"/> :
                <Fragment>
                  <Radio key={index} label={txt} value={txt} name={id}
                    on_change={()=>on_answer(index)}
                    checked={checked.has(index)}/>
                  {options && <div className={styles.survey_choiceoptions}>
                    {options.map((option, opt_index)=>{
                        const opt_checked = checked.has(index) &&
                            options_checked.has(opt_index);
                        return <Checkbox key={opt_index} caption={option}
                          icon={icon} checked={opt_checked} light
                          on_change={()=>{
                            on_choose_option(index, opt_index);
                          }} size="sm" color="primary"/>;
                    })}
                  </div>}
                </Fragment>}
            </div>;
        })}
        {other && <div className={cn(styles.survey_choice, theme.P,
          theme.p2, checked.has('other') && styles.chosen)}>
          {multiple ? <Checkbox checked={checked.has('other')} size="sm"
            on_change={()=>on_answer('other')} light
            icon={icon} caption="Other (please specify)"
            color="primary"/> : <Radio label="Other (please specify)"
            value="other" name={id} on_change={on_answer}/>}
          <Textarea placeholder="Type your message here" on_change={on_edit}
            value={msg} cls={styles.other} min_height={88}/>
        </div>}
      </div>
    </div>;
};
